import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, ClockIcon } from 'lucide-react';
interface FooterProps {
  isDark: boolean;
  minimal?: boolean;
}
export function Footer({
  isDark,
  minimal = false
}: FooterProps) {
  return <footer className="border-t border-slate-200 dark:border-white/5 pt-16 pb-8 bg-white dark:bg-[#0f1629] transition-colors duration-300 relative z-10" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className={`${minimal ? 'flex justify-center' : 'grid grid-cols-1 md:grid-cols-4 gap-12'} mb-12`} data-id="element-185">
          <div className={minimal ? 'text-center' : 'md:col-span-1'} data-id="element-186">
            <Link to="/" className={`flex items-center gap-2.5 mb-4 group ${minimal ? 'justify-center' : ''}`} data-id="element-187">
              <img src={isDark ? 'https://cdn.magicpatterns.com/uploads/ijbn574AJz6iw1qrM49TjL/Blue_and_Black_Minimalist_Brand_Logo_-_4.png' : 'https://cdn.magicpatterns.com/uploads/5vDwqvkMZA2x7h9wkDud7B/Blue_and_Black_Minimalist_Brand_Logo_-_2.png'} alt="Scale Finance Strategies" className="h-8 w-8 rounded-lg object-contain" data-id="element-188" />
              <span className="text-lg font-bold tracking-tight text-slate-900 dark:text-white" data-id="element-189">
                Scale
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-500 to-primary-500" data-id="element-190">
                  FinanceStrategies
                </span>
              </span>
            </Link>
            <p className={`text-slate-500 dark:text-slate-400 text-xs leading-relaxed ${minimal ? 'max-w-md mx-auto' : ''}`} data-id="element-191">
              Built for Australians that want more than just one property — we
              help you scale your portfolio through smarter strategy, education
              and the right team.
            </p>

            <div className={`mt-5 space-y-3 ${minimal ? 'inline-flex flex-col items-center' : ''}`} data-id="element-192">
              <div className="flex items-center gap-2.5" data-id="element-193">
                <MailIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-194" />
                <a href="mailto:info@scalefinancestrategies.com.au" className="text-xs text-slate-500 dark:text-slate-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-195">
                  info@scalefinancestrategies.com.au
                </a>
              </div>
              <div className="flex items-center gap-2.5" data-id="element-196">
                <ClockIcon className="w-4 h-4 text-primary-500 flex-shrink-0" data-id="element-197" />
                <span className="text-xs text-slate-500 dark:text-slate-400" data-id="element-198">
                  Mon – Fri: 8:30 AM – 5:30 PM AWST
                </span>
              </div>
            </div>
          </div>

          {!minimal && <>
              <div data-id="element-199">
                <h4 className="text-slate-900 dark:text-white font-semibold mb-4 text-sm" data-id="element-200">
                  Quick Links
                </h4>
                <ul className="space-y-2.5 text-sm text-slate-500 dark:text-slate-400" data-id="element-201">
                  <li data-id="element-202">
                    <Link to="/#services" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-203">
                      Services
                    </Link>
                  </li>
                  <li data-id="element-204">
                    <Link to="/tools" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-205">
                      Interactive Tools
                    </Link>
                  </li>
                  <li data-id="element-206">
                    <Link to="/#about" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-207">
                      About
                    </Link>
                  </li>
                  <li data-id="element-208">
                    <Link to="/#contact" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-209">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>

              <div data-id="element-210">
                <h4 className="text-slate-900 dark:text-white font-semibold mb-4 text-sm" data-id="element-211">
                  Services
                </h4>
                <ul className="space-y-2.5 text-sm text-slate-500 dark:text-slate-400" data-id="element-212">
                  <li data-id="element-213">
                    <Link to="/first-home-buyers" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-214">
                      For First Home Buyers
                    </Link>
                  </li>
                  <li data-id="element-215">
                    <Link to="/home-buyers" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-216">
                      For Home Buyers
                    </Link>
                  </li>
                  <li data-id="element-217">
                    <Link to="/investors" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-218">
                      For Investors
                    </Link>
                  </li>
                  <li data-id="element-219">
                    <Link to="/portfolio-strategy" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-220">
                      Portfolio Strategy
                    </Link>
                  </li>
                </ul>
              </div>

              <div data-id="element-221">
                <h4 className="text-slate-900 dark:text-white font-semibold mb-4 text-sm" data-id="element-222">
                  Legal
                </h4>
                <ul className="space-y-2.5 text-sm text-slate-500 dark:text-slate-400" data-id="element-223">
                  <li data-id="element-224">
                    <a href="#" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-225">
                      Privacy Policy
                    </a>
                  </li>
                  <li data-id="element-226">
                    <a href="#" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-227">
                      Terms of Service
                    </a>
                  </li>
                  <li data-id="element-228">
                    <a href="#" className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors" data-id="element-229">
                      Disclaimer
                    </a>
                  </li>
                </ul>
              </div>
            </>}
        </div>

        <div className="pt-8 border-t border-slate-200 dark:border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-230">
          <p className="text-xs text-slate-400 dark:text-slate-500 text-center md:text-left" data-id="element-231">
            © 2026 Scale Finance Strategies Pty Ltd. All rights reserved. ACN
            654344260
          </p>
          <p className="text-xs text-slate-400 dark:text-slate-500 max-w-xl text-center md:text-right leading-relaxed" data-id="element-232">
            General Advice Warning: All information on this website is general
            in nature and does not consider your personal circumstances. Any
            tools, calculators, or examples provided are for illustrative
            purposes only and may not be accurate or reflect your situation. You
            should seek personalised advice before making any financial
            decisions.
          </p>
        </div>
      </div>
    </footer>;
}